export default __webpack_public_path__ + "static/media/soc2-aws.d3f5847c.png";